import { render, staticRenderFns } from "./FeOpinionText.vue?vue&type=template&id=09abcf0b&scoped=true&"
import script from "./FeOpinionText.vue?vue&type=script&lang=js&"
export * from "./FeOpinionText.vue?vue&type=script&lang=js&"
import style0 from "./FeOpinionText.vue?vue&type=style&index=0&id=09abcf0b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09abcf0b",
  null
  
)

export default component.exports